import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const MapPinIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      width="28"
      height="34"
      viewBox="0 0 28 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 29.5747L21.7 21.8289C23.2227 20.297 24.2597 18.3452 24.6797 16.2205C25.0998 14.0957 24.8841 11.8933 24.0599 9.89189C23.2357 7.89044 21.8401 6.17978 20.0494 4.97623C18.2588 3.77267 16.1536 3.13028 14 3.13028C11.8464 3.13028 9.74122 3.77267 7.95058 4.97623C6.15993 6.17978 4.76428 7.89044 3.94009 9.89189C3.1159 11.8933 2.9002 14.0957 3.32026 16.2205C3.74032 18.3452 4.77728 20.297 6.3 21.8289L14 29.5747ZM14 34L4.10045 24.0416C2.14253 22.072 0.809179 19.5626 0.269 16.8307C-0.271179 14.0988 0.00607731 11.2672 1.06571 8.69379C2.12534 6.12042 3.91975 3.92093 6.22204 2.37345C8.52432 0.825965 11.2311 0 14 0C16.7689 0 19.4757 0.825965 21.778 2.37345C24.0802 3.92093 25.8747 6.12042 26.9343 8.69379C27.9939 11.2672 28.2712 14.0988 27.731 16.8307C27.1908 19.5626 25.8575 22.072 23.8996 24.0416L14 34ZM14 17.2128C14.8251 17.2128 15.6164 16.883 16.1999 16.2961C16.7833 15.7092 17.1111 14.9132 17.1111 14.0831C17.1111 13.2531 16.7833 12.4571 16.1999 11.8702C15.6164 11.2833 14.8251 10.9535 14 10.9535C13.1749 10.9535 12.3836 11.2833 11.8001 11.8702C11.2167 12.4571 10.8889 13.2531 10.8889 14.0831C10.8889 14.9132 11.2167 15.7092 11.8001 16.2961C12.3836 16.883 13.1749 17.2128 14 17.2128ZM14 20.3424C12.3498 20.3424 10.7671 19.6829 9.60023 18.5091C8.43333 17.3352 7.77778 15.7432 7.77778 14.0831C7.77778 12.4231 8.43333 10.831 9.60023 9.6572C10.7671 8.48336 12.3498 7.82391 14 7.82391C15.6502 7.82391 17.2329 8.48336 18.3998 9.6572C19.5667 10.831 20.2222 12.4231 20.2222 14.0831C20.2222 15.7432 19.5667 17.3352 18.3998 18.5091C17.2329 19.6829 15.6502 20.3424 14 20.3424Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default MapPinIcon;

MapPinIcon.propTypes = customIconsPropTypes;
